import React from 'react';
import { PictureIcon } from './PictureIcon';
import { useHandleFileChangeWrapper } from '../utils';
export var ImageUploadButton = function (_a) {
    var _b = _a.multiple, multiple = _b === void 0 ? false : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, handleFiles = _a.handleFiles, _d = _a.children, children = _d === void 0 ? React.createElement(PictureIcon, null) : _d, _e = _a.resetOnChange, resetOnChange = _e === void 0 ? false : _e;
    var onFileChange = useHandleFileChangeWrapper(resetOnChange, handleFiles);
    return (React.createElement("div", { className: "rfu-image-upload-button" },
        React.createElement("label", null,
            React.createElement("input", { "aria-label": "Image input", type: "file", className: "rfu-image-input", onChange: onFileChange, accept: "image/*", multiple: multiple, disabled: disabled }),
            children)));
};
